<template>
	<div v-if="dataLoaded">
		<v-toolbar color="blue lighten-1" class="white--text">
			<v-icon color="white">assessment</v-icon>
			<v-toolbar-title>Dane konkursu</v-toolbar-title>
		</v-toolbar>
		<div class="ma-4">
			<v-layout row align-center>
				<v-flex xs1/>
				<v-flex xs3>
					<v-subheader><strong>Nazwa konkursu</strong></v-subheader>
				</v-flex>
				<v-flex xs6>
					{{contest.name}}
				</v-flex>
			</v-layout>
			<v-layout row align-center>
				<v-flex xs1/>
				<v-flex xs3>
					<v-subheader><strong>Skrócona nazwa konkursu</strong></v-subheader>
				</v-flex>
				<v-flex xs6>
					{{contest.shortName}}
				</v-flex>
			</v-layout>
			<v-layout row align-center>
				<v-flex xs1/>
				<v-flex xs3>
					<v-subheader><strong>Początek naboru ofert</strong></v-subheader>
				</v-flex>
				<v-flex xs6>
					{{contest.contestStartDateTime}}
				</v-flex>
			</v-layout>
			<v-layout row align-center>
				<v-flex xs1/>
				<v-flex xs3>
					<v-subheader><strong>Koniec naboru ofert</strong></v-subheader>
				</v-flex>
				<v-flex xs6>
					{{contest.contestEndDateTime}}
				</v-flex>
			</v-layout>
			<v-layout row align-center>
				<v-flex xs1/>
				<v-flex xs3>
					<v-subheader><strong>Ramy czasowe projektów</strong></v-subheader>
				</v-flex>
				<v-flex xs6>
					{{contest.projectStartDate}} - {{contest.projectEndDate}}
				</v-flex>
			</v-layout>
			<v-layout row align-center>
				<v-flex xs1/>
				<v-flex xs3>
					<v-subheader><strong>Ogłoszenie konkursu</strong></v-subheader>
				</v-flex>
				<v-flex xs6>
					<div v-if="contest.contestPage">{{contest.contestPage}}
						<v-btn flat icon class="hidden-xs-only" @click="openTab(contest.contestPage)">
							<v-icon>open_in_new</v-icon>
						</v-btn>
					</div>
					<div v-else><i>Brak</i></div>
				</v-flex>
			</v-layout>
			<v-layout row align-center>
				<v-flex xs1/>
				<v-flex xs3>
					<v-subheader><strong>Wyniki konkursu</strong></v-subheader>
				</v-flex>
				<v-flex xs6>
					<div v-if="contest.resultPage">{{contest.resultPage}}
						<v-btn flat icon class="hidden-xs-only" @click="openTab(contest.resultPage)">
							<v-icon>open_in_new</v-icon>
						</v-btn>
					</div>
					<div v-else><i>Brak</i></div>
				</v-flex>
			</v-layout>
		</div>
	</div>
</template>

<script>
	import {PublicContest} from "../../../../api/generated/PublicContest";

	export default {
		name: "ContestSummaryDataView",

		data () {
			return {
				contest: null,
				dataLoaded: false
			};
		},

		created () {
			this.getContestSummaryMainData();
		},

		methods: {
			getContestSummaryMainData () {
				PublicContest.getSummaryMainData(this, this.$route.params.id, successResponse => {
						this.contest = successResponse;
						this.dataLoaded = true;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować danych konkursu", errorResponse);
					});
			},

			openTab (link) {
				window.open('//' + link, "_blank");
			}
		}
	};
</script>

<style scoped>

</style>